/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/canvas_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/canvas_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  include_archived: z.boolean().nullable().optional(),
  territory_ids: z.array(common.objectId).nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/canvas_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  include_archived: z.boolean(),
  territory_ids: z.array(common.objectId),
});
